import { render, staticRenderFns } from "./AmericanSyllable.vue?vue&type=template&id=b9ec506a&scoped=true"
import script from "./AmericanSyllable.vue?vue&type=script&lang=js"
export * from "./AmericanSyllable.vue?vue&type=script&lang=js"
import style0 from "./AmericanSyllable.vue?vue&type=style&index=0&id=b9ec506a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ec506a",
  null
  
)

export default component.exports